export default {
	inputData: new Object,
}



// WEBPACK FOOTER //
// ./src/mixins/config.js